import React from 'react'
import classes from '../FitnessPreview.module.scss'
const ArrowIconSvg = () => {
    return (
    <svg className={classes.icon} width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="43" height="43" rx="21.5" fill="#F2F7FB" />
        <rect x="0.5" y="0.5" width="43" height="43" rx="21.5" stroke="white" />
        <path d="M27.0581 19.9753L21.9997 14.917L16.9414 19.9753" stroke="#3ECAE3" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M22 29.0836V15.0586" stroke="#3ECAE3" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
    )
}

export default ArrowIconSvg;